  <template>
    <div>
      <div class="row tab-row-data m-0 flex-wrap">
        <div class="col-xxl-2 col-xl-6">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Basic details</h5>
          <div class="row">
            <div class="col-12">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Postcode <i class="ti ti-search" v-if="permissions.includes('lookup')"
                    style="cursor: pointer;" @click="openModal(formData.quoteDetails.PostCode, 'postcode')"></i></label>
                <span class="text-danger">*</span>
                <input type="text" class="form-control" v-model="formData.quoteDetails.PostCode" />
                <span class="text-danger" v-if="isElecNotValid && (formData.quoteDetails.PostCode === '')">Postcode is
                  required</span>
              </div>
            </div>
            <div class="col-12">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Top Line <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="formData.quoteDetails.ElectricSupply.MPANTop" />
                <span class="text-danger"
                  v-if="isElecNotValid && (formData.quoteDetails.ElectricSupply.MPANTop === '')">Mpan top is
                  required</span>
              </div>
            </div>
            <div class="col-12">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Bottom Line <i class="ti ti-search" v-if="permissions.includes('lookup')"
                    style="cursor: pointer;"
                    @click="electra_link_set ? searchPowwrMpan(formData.quoteDetails.ElectricSupply.MPANBottom) : openModal(formData.quoteDetails.ElectricSupply.MPANBottom, 'mpan')"></i></label>
                <span class="text-danger">*</span>
                <input type="text" class="form-control" v-model="formData.quoteDetails.ElectricSupply.MPANBottom" />
                <span class="text-danger"
                  v-if="isElecNotValid && (formData.quoteDetails.ElectricSupply.MPANBottom === '')">Mpan bottom is
                  required</span>
              </div>
            </div>
              <!-- LineLossFactorClass -->
            <div class="col-12">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Line Loss Factor Class</label>
                <input type="text" class="form-control" v-model="formData.quoteDetails.LineLossFactorClass" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-5 col-xl-6">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Usage details</h5>
          <div class="row">
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Annual Day Usage (kWh) <span class="text-danger">*</span>
                </label>
                <input type="number" class="form-control"
                  v-model="formData.quoteDetails.ElectricSupply.DayConsumption.Amount" @blur="calculateCurrentCost" />
                <span class="text-danger"
                  v-if="isElecNotValid && !Number(formData.quoteDetails.ElectricSupply.DayConsumption.Amount)">Annual Day
                  Usage is required</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Old day rate (pence/kWh)
                </label>
                <input type="number" class="form-control"
                  v-model="formData.quoteDetails.ElectricSupply.OldDayConsumption.Amount"
                  @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Annual Night Usage (kWh)
                </label>
                <input type="number" class="form-control"
                  v-model="formData.quoteDetails.ElectricSupply.NightConsumption.Amount" @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Old Night Rate (pence/kWh)
                </label>
                <input type="number" class="form-control"
                  v-model="formData.quoteDetails.ElectricSupply.OldNightConsumption.Amount"
                  @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Annual Weekend Usage (kWh)
                </label>
                <input type="number" class="form-control"
                  v-model="formData.quoteDetails.ElectricSupply.WendConsumption.Amount" @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Old Weekend Rate (pence/kWh)
                </label>
                <input type="number" class="form-control"
                  v-model="formData.quoteDetails.ElectricSupply.OldWendConsumption.Amount"
                  @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Feed-In Tariff (FiT) (pence/kWh)
                </label>
                <input type="number" class="form-control" v-model="formData.quoteDetails.FeedTariff"
                  @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Standing Charge (pence/day)
                </label>
                <input type="number" class="form-control" v-model="formData.quoteDetails.StandingCharge"
                  @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">kVA
                </label>
                <input type="number" class="form-control"
                  v-model="formData.quoteDetails.ElectricSupply.KvaConsumption.Amount" @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">kVA Rate (p/day)
                </label>
                <input type="number" class="form-control"
                  v-model="formData.quoteDetails.ElectricSupply.KvadayConsumption" @blur="calculateCurrentCost" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Current Cost (£)
                </label>
                <input type="number" class="form-control" v-model="formData.quoteDetails.CurrentCost"
                  @blur="calculateCurrentCost" />
              </div>
            </div>
                     <!-- Duos Tariff Id -->
            <div class="col-4">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Duos Tariff Id</label>
                <input type="text" class="form-control" v-model="formData.quoteDetails.DuosTariffId"/>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xxl-3 col-xl-6">
          <h5 class="bg-teal p-2 mb-3 rounded text-center">Contract details</h5>
          <div class="row">

            <div class="col-md-12" ref="dropdownContainer">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Current Supplier <span class="text-danger">*</span></label>
                <Field name="organisation_id" type="text" class="form-control" placeholder="Search Supplier name"
                  v-model="searchQuery" @keydown.enter="searchSupplier" @input="onInput" @focus="showDropdown"
                  autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
                <ul v-if="filteredSuppliers.length" class="dropdown-menu supplier-data shadow show pe-0">
                  <li class="dropdown-listing">
                    <ul>
                      <li v-for="res in filteredSuppliers" :key="res.id" @click="selectSupplier(res)"
                        class="dropdown-item" style="cursor: pointer;">
                        {{ res.name }}
                      </li>
                    </ul>
                  </li>
                </ul>
                <span class="text-danger"
                  v-if="isElecNotValid && (formData.quoteDetails.CurrentSupplier === '')">Current supplier is
                  required</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Payment Type</label>
                <Field as="select" name="new_supplier_id" class="form-select"
                  v-model="formData.quoteDetails.PaymentMethod">
                  <option v-for="res in dropdownOptions.contract_payment_type" :key="res.value" :value="res.value">
                    {{ res.text }}
                  </option>
                </Field>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Start Date
                </label>
                <div class="icon-form">
                  <date-time-picker
                    v-model="formData.quoteDetails.ElectricSupply.ContractRenewalDate"
                    text-input
                    format="dd/MM/yyyy"
                    auto-apply
                    :enable-time-picker="false"
                    :disabled=false
                    :clearable=true
                  />
                </div>
                <!-- <span class="text-danger" v-if="isElecNotValid && (formData.quoteDetails.ElectricSupply.ContractRenewalDate === '')">Start Date is required</span> -->
                <span class="text-danger"
                  v-if="isElecNotValid && formData.quoteDetails.ElectricSupply.ContractRenewalDate && (new Date(formData.quoteDetails.ElectricSupply.ContractRenewalDate) <= new Date())">Renewal
                  date should be greater than current date.</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Unit Rate Uplift</label>
                <Field as="select" name="uplift" class="form-select" v-model="formData.uplift_text">
                  <option v-for="res in unitRateUplift" :key="res.value" :value="res.value">
                    {{ res.text }}
                  </option>
                </Field>
              </div>
            </div>
            <div v-if="formData.uplift_text !== 'maximum' && formData.uplift_text !== 'minimum'" class="col-md-6">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Invariable</label>
                <input type="text" class="form-control" v-model="invarUplift" @change="changeUplift" />
                <span class="text-danger" v-if="isElecNotValid && (formData.quoteDetails.Uplift === null)">Unit Rate
                  Uplift is required</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Email</label>
                <input type="email" class="form-control" v-model="formData.quoteDetails.Email" />
                <span class="text-danger"
                  v-if="isElecNotValid && isEmailValid && (formData.quoteDetails.Email === '')">Email is
                  required</span>
                <span class="text-danger" v-if="isElecNotValid && validateEmail(formData.quoteDetails.Email)">Email must
                  be valid Address</span>
                <span class="text-danger"
                  v-if="validEmail && validEmail['formData.email'] && validEmail['formData.email'].length">
                  {{ validEmail['formData.email'][0] }}
                </span>
              </div>
            </div>
                      <!-- Meter Timeswitch Class -->
            <div class="col-6">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Meter Timeswitch Class</label>
                <input type="text" class="form-control" v-model="formData.quoteDetails.MeterTimeswitchClass" />
              </div>
            </div>

            <!-- Mhhs Migrated -->
            <div class="col-6">
              <div class="form-wrap mb-2">
                <label class="col-form-label">Mhhs Migrated</label>
                <select class="form-select" v-model="formData.quoteDetails.MhhsMigrated">
                  <option value="Legacy">Legacy</option>
                  <option value="Migrated">Migrated</option>
                  <option value="Reverse Migrated">Reverse Migrated</option>
                </select>
              </div>
            </div>

          </div>
        </div>
        <div class="col-xxl-2 col-xl-6">
  <h5 class="bg-teal p-2 mb-3 rounded text-center">Additional details</h5>
  <div class="row g-2">

    <!-- Credit Score -->
    <div class="col-12">
      <div class="form-wrap mb-2">
        <label class="col-form-label">Credit Score</label>
        <input type="text" class="form-control" v-model="formData.quoteDetails.Settings[1].value" />
        <span class="text-danger" v-if="isElecNotValid && (formData.quoteDetails.Settings[1].value === '0')">
          Credit Score is required
        </span>
      </div>
    </div>

    <!-- Measurement Class -->
    <div class="col-12">
      <div class="form-wrap mb-2">
        <label class="col-form-label">Measurement Class</label>
        <input type="text" class="form-control" v-model="formData.quoteDetails.ElectricSupply.MeasurementClass" />
      </div>
    </div>

    <!-- Profile Class -->
    <div class="col-12">
      <div class="form-wrap mb-2">
        <label class="col-form-label">Profile Class</label>
        <input type="text" class="form-control" v-model="formData.quoteDetails.ProfileClass" />
      </div>
  </div>

    <!-- Meter Type -->
    <div class="col-12">
      <div class="form-wrap mb-2">
        <label class="col-form-label">Meter Type 
          <!-- <i class="ti ti-search" style="cursor: pointer;" @click="openModal(formData.quoteDetails.ElectricSupply.MeterType)"></i> -->
        </label>
        <input type="text" class="form-control" v-model="formData.quoteDetails.ElectricSupply.MeterType" />
      </div>
    </div>

    <!-- SSC -->
    <div class="col-12">
      <div class="form-wrap mb-2">
        <label class="col-form-label">SSC 
          <!-- <i class="ti ti-search" style="cursor: pointer;" @click="openModal(formData.quoteDetails.ElectricSupply.StandardSettlementConfig)"></i> -->
        </label>
        <input type="text" class="form-control" v-model="formData.quoteDetails.ElectricSupply.StandardSettlementConfig" />
      </div>
    </div>

  </div>
</div>

      </div>
    </div>
    <look-up-modal :formData="formData" :isVisible="isModalVisible" :searchPostcode="selectedPostcode"
      :selectedLabel="selectedLabel" @close="closeModal"></look-up-modal>
    <electric-look-up-modal :formData="formData" :isVisible="isVisible" :electricLinkData="electricData"
      :isPowwrData="isPowwrData" :electricDataRawPowwr="electricDataRawPowwr"
      @close="closeModal"></electric-look-up-modal>
  </template>

<script>
import {
  ref,
  onMounted,
  watch,
  computed,
} from "vue";
import {
  useStore
} from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";
import {
  Form,
  Field,
  ErrorMessage
} from "vee-validate";

export default {
  props: {
    isElecNotValid: {
      type: Boolean,
      default: false,
    },
    isEmailValid: {
      type: Boolean,
      default: false,
    },
    elecOppId: {
      type: Number,
      default: null,
    },
    validEmail: {
      type: Object,
      default: {},
    }
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      dateFormat: "dd/MM/yyyy",
    };
  },
  setup(props, {
    emit
  }) {
    const store = useStore();
    const route = useRoute();
    const filteredSuppliers = ref([]);
    const searchQuery = ref('');
    const dropdownContainer = ref(null);
    const selectedPostcode = ref('');
    const selectedLabel = ref('');
    const isModalVisible = ref(false);
    const isVisible = ref(false);
    const opp_Id = ref(route.query.opp_Id);
    const invarUplift = ref('0.2');
    const upliftValue = ref(null);
    const unitRateUplift = ref([
      { value: "maximum", text: "Maximum" }, { value: "minimum", text: "Minimum" }, { value: 'invariable', text: "Invariable" }
    ])
    // const permissions = ref(JSON.parse(localStorage.getItem('user')).permissions || [])
    const permissions = computed(() => {
      const user = store.getters['auth/user']
      return user.permissions;
    })
    const supplierOptions = computed(
      () => store.getters["price/getSuppliers"]
    );
    const dropdownOptions = computed(
      () => store.getters["price/getDropdowns"]
    );

    const electra_link_set = computed(
      () => store.getters["price/getElectraLink"]
    );

    const electricData = ref({})
    const electricDataRawPowwr = ref(null)
    const isPowwrData = ref(false)

    const formData = ref({
      mainProductService: "elec",
      uplift_text: 'maximum',
      quoteDetails: {
        PostCode: "",
        Uplift: invarUplift.value || '0.2',
        PaymentMethod: "monthly direct debit",
        CurrentSupplier: "",
        OldRate: "0",
        StandingCharge: "0",
        FeedTariff: "0.",
        CurrentCost: "0",
        EnableQuoteEmail: false,
        QuoteReference: "",
        Email: "",
        BusinessType: "ltd",
        SaleType: "",
        ElectricSupply: {
          DayConsumption: { //Annual Day Usage (kWh)
            Amount: 0,
            Type: "Day"
          },
          OldDayConsumption: { //Annual Day Usage (kWh)
            Amount: 0,
            Type: "Day"
          },
          NightConsumption: { //Annual Night Usage
            Amount: 0,
            Type: "Night"
          },
          OldNightConsumption: { //Annual Day Usage (kWh)
            Amount: 0,
            Type: "Day"
          },
          WendConsumption: {
            Amount: 0,
            Type: "Weekend"
          },
          OldWendConsumption: {
            Amount: 0,
            Type: "OldWeekend"
          },
          KvaConsumption: {
            Amount: 0,
          },
          MPANTop: null,
          MPANBottom: null,
          ContractRenewalDate: null, // Renewal Date
          start_date:null,
          KvadayConsumption: '',
          MeasurementClass: "",
          StandardSettlementConfig: "",
          SmartMeter: false,
          MeterType: null,
          ProfileClass:null,
          MeterTimeswitchClass:null,
          LineLossFactorClass:null,
          DuosTariffId:null,
          MhhsMigrated:"Legacy"
        },
        Settings: [{
          key: "upliftBehaviour",
          value: "closest"
        },
        {
          key: "CreditScore",
          value: ""
        },
        {
          key: "ShowNoQuoteReason",
          value: "true"
        }
        ],
      },
    });
    const onInput = () => {
      searchSupplier();
    };

    const searchSupplier = () => {
      const query = searchQuery.value.toLowerCase();
      if (query) {
        filteredSuppliers.value = supplierOptions.value.filter((org) => {
          const nameMatch = org.name.toLowerCase().includes(query);
          return nameMatch;
        });
      } else {
        // If the query is empty, hide the dropdown
        filteredSuppliers.value = [];
      }
    };

    const showDropdown = () => {
      // Show all organisations when the input is focused (clicked)
      if (!searchQuery.value) {
        filteredSuppliers.value = supplierOptions.value;
      }
    };

    const selectSupplier = (organisation) => {
      formData.value.quoteDetails.CurrentSupplier = organisation.name;
      searchQuery.value = organisation.name;

      filteredSuppliers.value = [];
    };

    const openModal = (code, label) => {
      selectedPostcode.value = code; // Assign the clicked value to selectedPostcode
      selectedLabel.value = label;
      isModalVisible.value = true;
    };

    const closeModal = () => {
      isModalVisible.value = false;
      isVisible.value = false;
      isPowwrData.value = false;
      electricDataRawPowwr.value = null;
    };

    const hideDropdown = () => {
      filteredSuppliers.value = [];
    };

    const handleClickOutside = (event) => {
      // Check if the click happened outside the dropdown container
      if (dropdownContainer.value && !dropdownContainer.value.contains(event.target)) {
        hideDropdown();
      }
    };
    const emitFormData = () => {
      emit("submit-elctric-form", formData.value);
    };
    const calculateCurrentCost = (shouldPersist = true) => {
      // Helper function to safely parse and handle NaN
      const parseAmount = (value) => parseFloat(value) || 0;

      // Extracting form data values for easier access
      const electricSupply = formData.value.quoteDetails.ElectricSupply;
      const feedTariff = parseAmount(formData.value.quoteDetails.FeedTariff);
      const standingCharge = parseAmount(formData.value.quoteDetails.StandingCharge);

      // Old rate annual price calculations
      const annualPrice = parseAmount(electricSupply.DayConsumption.Amount);
      const oldDayPrice = parseAmount(electricSupply.OldDayConsumption.Amount);
      const annual_rate = (annualPrice * oldDayPrice) / 100;

      const annualNightPrice = parseAmount(electricSupply.NightConsumption.Amount);
      const oldNightPrice = parseAmount(electricSupply.OldNightConsumption.Amount);
      const night_rate = (annualNightPrice * oldNightPrice) / 100;

      const annualWeekendPrice = parseAmount(electricSupply.WendConsumption.Amount);
      const oldWeekendPrice = parseAmount(electricSupply.OldWendConsumption.Amount);
      const weekend_rate = (annualWeekendPrice * oldWeekendPrice) / 100;

      const kvaConsumption = parseAmount(electricSupply.KvaConsumption.Amount);
      const kvaDayConsumption = parseAmount(electricSupply.KvadayConsumption);
      const kvaConsumption_rate = (kvaConsumption * kvaDayConsumption * 365) / 100;

      // Feed tariff calculations
      const feed_annual_rate = (annualPrice * feedTariff) / 100;
      const feed_value_rate = feed_annual_rate + (annualNightPrice * (oldNightPrice + feedTariff)) / 100;

      // Standing charge calculation
      const standingChargeCost = (standingCharge * 365) / 100;

      // Calculate total cost based on feed_value_rate
      let totalCost;
      if (feed_value_rate !== 0) {
        totalCost = annual_rate + weekend_rate + standingChargeCost + kvaConsumption_rate + feed_value_rate;
      } else {
        totalCost = annual_rate + night_rate + weekend_rate + standingChargeCost + kvaConsumption_rate + feed_value_rate;
      }

      // Update the current cost in formData
      formData.value.quoteDetails.CurrentCost = totalCost.toFixed(2);
      if (shouldPersist !== false) {
        persistCurrentPrices();
      }
    };

    const persistCurrentPrices = async () => {
      const opportunityId = opp_Id.value || props.elecOppId;
      if (!opportunityId) return;
      await store.dispatch('opportunity/saveCurrentPrices', {
        opportunityId,
        current_prices: {
          elec: {
            OldDayRate: formData.value.quoteDetails.ElectricSupply.OldDayConsumption.Amount,
            OldNightRate: formData.value.quoteDetails.ElectricSupply.OldNightConsumption.Amount,
            OldWeekendRate: formData.value.quoteDetails.ElectricSupply.OldWendConsumption.Amount,
            StandingCharge: formData.value.quoteDetails.StandingCharge,
            FeedTariff: formData.value.quoteDetails.FeedTariff,
            KvaRate: formData.value.quoteDetails.ElectricSupply.KvadayConsumption,
            CurrentCost: formData.value.quoteDetails.CurrentCost,
          },
        },
      });
    };

    const fetchOppData = async (id) => {
      const data = await store.dispatch('opportunity/fetchOpportunity', id);
      if (Object.keys(data).length > 0) {
        formData.value.quoteDetails.PostCode = data.supply_address.postcode;
        formData.value.quoteDetails.PaymentMethod = data.organization.payment_type || 'monthly direct debit';
        formData.value.quoteDetails.ElectricSupply.MPANTop = data.mpan_top;
        formData.value.quoteDetails.ElectricSupply.MPANBottom = data.mpan_bottom;
        // formData.value.quoteDetails.ElectricSupply.DayConsumption.Amount = data.forecast_commission.sc_forecast_or_amended_annual_consumption;
        // Renewal Date uses contract_start_date when loading from meter opportunity (Get quote).
        formData.value.quoteDetails.ElectricSupply.ContractRenewalDate =
          data.contract_start_date ? new Date(data.contract_start_date) : new Date();
        formData.value.quoteDetails.ElectricSupply.start_date = data.contract_start_date ? new Date(data.contract_start_date) : null; 

        formData.value.quoteDetails.ElectricSupply.KvaConsumption.Amount = data.forecast_commission.kva;
        // upliftValue.value = data.forecast_commission.u4b_uplift || '';
        // formData.value.quoteDetails.Uplift = upliftValue.value;
        // formData.value.uplift_text = upliftValue.value;

        invarUplift.value = data.forecast_commission.u4b_uplift === '0.00' ? '0.2' : data.forecast_commission.u4b_uplift;
        formData.value.quoteDetails.Uplift = invarUplift.value;

        formData.value.uplift_text = 'invariable';

        searchQuery.value = filterSupplier(data.supplier_id);
        formData.value.quoteDetails.CurrentSupplier = searchQuery.value;
        formData.value.quoteDetails.Email = data.sales_contact_email || '';
        formData.value.quoteDetails.SaleType = data.sale_type || '';

        // New Fields
        const newSupplier = filterSupplier(data.new_supplier_id);
        if (newSupplier === 'Pozitive Energy') {
          formData.value.quoteDetails.ElectricSupply.DayConsumption.Amount = data.forecast_commission.day_consumption;
          formData.value.quoteDetails.ElectricSupply.OldNightConsumption.Amount = data.forecast_commission.night_consumption;
          formData.value.quoteDetails.ElectricSupply.WendConsumption.Amount = data.forecast_commission.weekend_consumption;
        } else {
          formData.value.quoteDetails.ElectricSupply.DayConsumption.Amount = data.forecast_commission.sc_forecast_or_amended_annual_consumption;
        }

        const savedPrices = data.current_prices?.elec;
        if (savedPrices) {
          if (savedPrices.OldDayRate != null && savedPrices.OldDayRate !== '') {
            formData.value.quoteDetails.ElectricSupply.OldDayConsumption.Amount = savedPrices.OldDayRate;
          }
          if (savedPrices.OldNightRate != null && savedPrices.OldNightRate !== '') {
            formData.value.quoteDetails.ElectricSupply.OldNightConsumption.Amount = savedPrices.OldNightRate;
          }
          if (savedPrices.OldWeekendRate != null && savedPrices.OldWeekendRate !== '') {
            formData.value.quoteDetails.ElectricSupply.OldWendConsumption.Amount = savedPrices.OldWeekendRate;
          }
          if (savedPrices.StandingCharge != null && savedPrices.StandingCharge !== '') {
            formData.value.quoteDetails.StandingCharge = savedPrices.StandingCharge;
          }
          if (savedPrices.FeedTariff != null && savedPrices.FeedTariff !== '') {
            formData.value.quoteDetails.FeedTariff = savedPrices.FeedTariff;
          }
          if (savedPrices.KvaRate != null && savedPrices.KvaRate !== '') {
            formData.value.quoteDetails.ElectricSupply.KvadayConsumption = savedPrices.KvaRate;
          }
          if (savedPrices.CurrentCost != null && savedPrices.CurrentCost !== '') {
            formData.value.quoteDetails.CurrentCost = savedPrices.CurrentCost;
          } else {
            calculateCurrentCost(false);
          }
        }

        // When coming from opportunity flow, silently run MPAN lookup to backfill missing fields.
        // This mimics the "Bottom Line search icon" copy behavior, but ONLY fills empty fields.
        await populateMissingFromMpanLookup(formData.value.quoteDetails.ElectricSupply.MPANBottom);
      }
    }

    const isBlank = (v) => v === null || v === undefined || v === '';

    const populateMissingFromMpanLookup = async (mpanBottom) => {
      if (!mpanBottom) return;

      try {
        // Prefer Powwr when enabled, otherwise fall back to the existing lookup API.
        if (electra_link_set.value) {
          const resp = await store.dispatch("price/fetchPowwrMpanSearch", mpanBottom);
          const raw = resp?.raw;
          if (!raw || typeof raw !== 'object') return;

          // Only set values that are currently blank in the quoting form.
          if (isBlank(formData.value.quoteDetails.ElectricSupply.MeasurementClass)) {
            formData.value.quoteDetails.ElectricSupply.MeasurementClass = raw.measurementClass ?? '';
          }
          if (isBlank(formData.value.quoteDetails.ProfileClass)) {
            formData.value.quoteDetails.ProfileClass = raw.profileClass ?? '';
          }
          if (isBlank(formData.value.quoteDetails.ElectricSupply.StandardSettlementConfig)) {
            formData.value.quoteDetails.ElectricSupply.StandardSettlementConfig = raw.standardSettlementConfiguration ?? '';
          }
          if (isBlank(formData.value.quoteDetails.DuosTariffId)) {
            formData.value.quoteDetails.DuosTariffId = raw.duosTariffId ?? '';
          }
          if (isBlank(formData.value.quoteDetails.MeterTimeswitchClass)) {
            formData.value.quoteDetails.MeterTimeswitchClass = raw.meterTimeswitchClass ?? '';
          }
          if (isBlank(formData.value.quoteDetails.MhhsMigrated)) {
            formData.value.quoteDetails.MhhsMigrated = raw.mhhsIndicator ?? '';
          }
          if (formData.value.quoteDetails.Settings && formData.value.quoteDetails.Settings[1] && isBlank(formData.value.quoteDetails.Settings[1].value)) {
            formData.value.quoteDetails.Settings[1].value = 50;
          }
        } else {
          const paramsData = {
            search_type: 'mpan',
            search_value: mpanBottom,
            electra_link_set: electra_link_set.value
          };
          const electricLinkData = await store.dispatch("price/fetchLookupData", paramsData);
          if (!electricLinkData || typeof electricLinkData !== 'object') return;

          // Only set values that are currently blank in the quoting form.
          if (isBlank(formData.value.quoteDetails.ElectricSupply.StandardSettlementConfig)) {
            formData.value.quoteDetails.ElectricSupply.StandardSettlementConfig = electricLinkData?.standard_settlement_configuration_id ?? '';
          }
          if (isBlank(formData.value.quoteDetails.ElectricSupply.MeasurementClass)) {
            formData.value.quoteDetails.ElectricSupply.MeasurementClass = electricLinkData?.additional_detail?.[0]?.measurement_class ?? '';
          }
          if (isBlank(formData.value.quoteDetails.ProfileClass)) {
            formData.value.quoteDetails.ProfileClass = electricLinkData?.additional_detail?.[0]?.profile_class ?? '';
          }
          if (isBlank(formData.value.quoteDetails.MeterTimeswitchClass)) {
            formData.value.quoteDetails.MeterTimeswitchClass = electricLinkData?.additional_detail?.[0]?.mtc_id ?? '';
          }
          if (isBlank(formData.value.quoteDetails.DuosTariffId)) {
            // Not always present in ElectraLink response; keep best-effort.
            formData.value.quoteDetails.DuosTariffId = electricLinkData?.duos_tariff_id ?? '';
          }
          if (formData.value.quoteDetails.Settings && formData.value.quoteDetails.Settings[1] && isBlank(formData.value.quoteDetails.Settings[1].value)) {
            formData.value.quoteDetails.Settings[1].value = 50;
          }
        }
      } catch (e) {
        // Ignore silently; user can still use the lookup icon manually.
      }
    };
    const filterSupplier = (supplier_id) => {
      const supplier = supplierOptions.value.find(s => s.id === supplier_id);
      return supplier ? supplier.name : "";
    };
    const changeUplift = (event) => {
      const change_uplift = event.target.value;
      // upliftValue.value = change_uplift;
      formData.value.uplift_text = 'invariable';
      formData.value.quoteDetails.Uplift = change_uplift;
    }

    const searchMpan = async (mpan_bottom) => {
      if (mpan_bottom) {
        const paramsData = {
          search_type: 'mpan', // Pass selected search type
          search_value: mpan_bottom,
          electra_link_set: electra_link_set.value
        };
        // Dispatch the Vuex action with paramsData
        const response = await store.dispatch(
          "price/fetchLookupData",
          paramsData
        );

        if (response) {
          electricData.value = response;
          isPowwrData.value = false;
          electricDataRawPowwr.value = null;
          isVisible.value = true;
        }
      }
    };

    const searchPowwrMpan = async (mpan_bottom) => {
      if (mpan_bottom) {
        try {
          const response = await store.dispatch(
            "price/fetchPowwrMpanSearch",
            mpan_bottom
          );

          if (response && response.mapped !== undefined) {
            electricData.value = response.mapped;
            electricDataRawPowwr.value = response.raw ?? null;
            isPowwrData.value = true;
            isVisible.value = true;
          }
        } catch (err) {
          // Error already shown by store action
        }
      }
    };

    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email) {
        return false
      } else if (!emailRegex.test(email)) {
        return true
      }
    };

    watch(
      () => props.elecOppId,
      async (newValue) => {
        await store.dispatch("price/fetchSuppliers");
        if (newValue) {
          fetchOppData(newValue);
        }
      }
    );
    

    watch(
      () => formData.value.quoteDetails.CurrentSupplier,
      (newValue) => {
        searchQuery.value = newValue;
      }, { immediate: true }
    );

    onMounted(async () => {
      emitFormData();
      document.addEventListener('click', handleClickOutside);
      const personsTab = document.querySelector(
        '[data-bs-target="#electricity"]'
      );

      personsTab.addEventListener("shown.bs.tab", () => {
        store.dispatch("price/fetchSuppliers");
      });
      // if (props.elecOppId) {
      //   fetchOppData(props.elecOppId)
      // }
    });

    return {
      fetchOppData,
      invarUplift,
      upliftValue,
      filterSupplier,
      calculateCurrentCost,
      persistCurrentPrices,
      changeUplift,
      emitFormData,
      selectedLabel,
      selectedPostcode,
      openModal,
      closeModal,
      isModalVisible,
      isVisible,
      filteredSuppliers,
      dropdownContainer,
      handleClickOutside,
      hideDropdown,
      showDropdown,
      searchSupplier,
      searchQuery,
      selectSupplier,
      onInput,
      formData,
      supplierOptions,
      dropdownOptions,
      unitRateUplift,
      opp_Id,
      searchMpan,
      searchPowwrMpan,
      electricData,
      electricDataRawPowwr,
      isPowwrData,
      electra_link_set,
      permissions,
      validateEmail
    };
  },
};
</script>

<style scoped>
.tab-row-data {
  /* overflow-x: auto; */
  flex-wrap: inherit;
}

.supplier-data {
  width: 280px;
  max-height: 350px;
  overflow: auto;
}

.form-control,
.form-wrap span,
.col-form-label {
  font-size: 12px;
}

.not-valid {
  border-color: #FC0027;
}
</style>
